import React from "react";
import { useFormState } from "react-final-form";
import ExlyModal from "common/Components/ExlyModal";
import { QuestionFormFields } from "../../../common/QuestionFormFields/QuestionFormFields";
import { useEditQuestionModal } from "../../utils/useEditQuestionModal";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import styles from "./EditQuestionModalStyles.module.css";

export const EditQuestionModal = withComponentLibraryTheme(
  ({ handleSubmit, showQuestionPlacementField = true }) => {
    const formState = useFormState();
    const isDirty = formState.dirty;

    const { isEditQuestionModalOpen, closeEditQuestionModal } =
      useEditQuestionModal();

    return (
      <ExlyModal
        title="Edit question"
        header="Edit question"
        primaryBtnText="Save Changes"
        secondaryBtnText="Cancel"
        onSecondaryBtnClick={closeEditQuestionModal}
        onPrimaryBtnClick={handleSubmit}
        primaryBtnProps={{ disabled: !isDirty }}
        open={isEditQuestionModalOpen}
        onClose={closeEditQuestionModal}
        padded={false}
        showSecondaryBtn={true}
        modal_props={{
          modalPaperClassName: styles.modalPaper,
          secondaryBtnClassName: styles.secondaryBtn,
        }}
        mobile_modal_props={{
          secondaryAction: {
            label: "Cancel",
            onClick: closeEditQuestionModal,
            className: styles.secondaryBtn,
          },
        }}
      >
        <QuestionFormFields
          showQuestionPlacementField={showQuestionPlacementField}
        />
      </ExlyModal>
    );
  }
);
